import React from 'react'
import axios from 'axios';
import {
  Heading,
  Avatar,
  Box,
  Center,
  Image,
  Flex,
  Text,
  Stack,
  Link,
  Badge,
  Button,
  useColorModeValue,
  Divider,
  SimpleGrid,
  HStack,
} from '@chakra-ui/react';
import { EditIcon } from '@chakra-ui/icons'

import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  StackDivider,
} from '@chakra-ui/react';
import {

  chakra,
  Container,




  VStack,





  VisuallyHidden,
  List,
  ListItem,
} from '@chakra-ui/react';

export default function PPosition() {
  const [data, setData] = React.useState([]);
  React.useEffect(() => {
    axios.get('https://glb-api.onrender.com/student/projects')
    .then(res => {
      console.log(res.data);

      setData(res.data);
    })
    .catch(err => {
      console.log(err);
      // setError('Failed to fetch the details right now.')
    })
  }, [])
  return (
    <>
    <div>




          <Box>
      <Card  variant={'unstyled'} boxShadow="none" minH={"100vh"}>
      <CardBody>
    <Box
      bg="white"
      shadow="md"
      borderRadius="md"
      p="6"
      width="100%"

    >
      <Flex alignItems="center" justifyContent="space-between">
        <Heading as="h1" size="2xl">
          Projects
        </Heading>
        <Button
                  leftIcon={<EditIcon />}
                  marginTop={"4px"}
                  colorScheme="blue"
                  variant="outline"
                  size={'lg'}
                  display={{ base: 'none', md: 'inline-flex' }}
                  fontSize={'2xl'}
                  href={'#'}
                >
                  Edit info
                </Button>
      </Flex>

    </Box>

    <Box className='mt-10' >
      <VStack spacing={10}>
      <Center width={'100%'}>
    <Box width={'100%'}>
                  <Card variant={'elevated'}>
                  <CardHeader>
                        <Box bg="white" p={5} borderRadius="md">
                          <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                          {data.title}
                          </Heading>

                          <HStack spacing={10} marginTop={'20px'}>
                            <Box flex={1}>
                              <Heading as="h3" size="lg" mb={2}>
                                {data.organisation}
                              </Heading>
                              <Text
                                fontSize="xl"
                                fontWeight="bold"
                                color="gray.600"
                              >
                                {data.tenure?.start}-{data.tenure?.end}
                              </Text>
                            </Box>
                            <Box>
                            <Text
            textTransform={'uppercase'}
            color={'green.400'}
            fontWeight={600}
            fontSize={'lg'}
            bg={useColorModeValue('green.50', 'green.200')}
            p={2}
            alignSelf={'flex-start'}
            rounded={'md'}>
            {data.current == false ? ('completed'):('ongoing')}


          </Text>
                            </Box>
                          </HStack>
                        </Box>

                        <Divider marginTop={'10px'} />
                      </CardHeader>

                    <CardBody>
                      <SimpleGrid
                        columns={2}
                        spacingX="0px"


                      >
                        <Box height="50px">
                          <Text fontSize="2xl">title:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">{data.title}</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">organisation:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">{data.organisation}</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">location:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">{data.location}</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">Description:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">{data.description}</Text>
                        </Box>



                      </SimpleGrid>

                    </CardBody>
                  </Card>
                </Box>
  </Center>

  <Center width={'100%'}>
    <Box width={'100%'}>
                  <Card variant={'elevated'}>
                  <CardHeader>
                        <Box bg="white" p={5} borderRadius="md">
                          <Heading as="h2" textAlign="left" size="2xl" mb={3}>
                          Skynet
                          </Heading>

                          <HStack spacing={10} marginTop={'20px'}>
                            <Box flex={1}>
                              <Heading as="h3" size="lg" mb={2}>
                                Org X
                              </Heading>
                              <Text
                                fontSize="xl"
                                fontWeight="bold"
                                color="gray.600"
                              >
                                Nov 22 - Feb 23
                              </Text>
                            </Box>
                            <Box>
                            <Text
            textTransform={'uppercase'}
            color={'yellow.400'}
            fontWeight={600}
            fontSize={'lg'}
            bg={useColorModeValue('yellow.50', 'yellow.200')}
            p={2}
            alignSelf={'flex-start'}
            rounded={'md'}>
            ongoing
          </Text>
                            </Box>
                          </HStack>
                        </Box>

                        <Divider marginTop={'10px'} />
                      </CardHeader>

                    <CardBody>
                      <SimpleGrid
                        columns={2}
                        spacingX="0px"


                      >
                        <Box height="50px">
                          <Text fontSize="2xl">NAME:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">Rick Astley</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">DATE OF BIRTH:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">3-12-2000</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">GENDER:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">Male</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">E-MAIL:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">Signupandogin@gmail.com</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">Contact Details:</Text>
                        </Box>
                        <Box height="50px">
                          <Text fontSize="2xl">+91-3243276186</Text>
                        </Box>



                      </SimpleGrid>

                    </CardBody>
                  </Card>
                </Box>
  </Center>
      </VStack>

</Box>




  </CardBody>
      </Card>
    </Box>
    </div>
    </>
  )
}
